<template>
	<div class>
		<div class="row">
			<div class="col-12">
				<input
					:class="{ 'is-invalid': $v.nombre.$error }"
					class="form-control my-2 StyleInputText"
					placeholder="Nombre"
					ref="nombre"
					type="text"
					v-model="$v.nombre.$model"
				/>
			</div>
			<div class="col-12">
				
				<cleave
					:class="{ 'is-invalid': $v.telefono.$error }"
					:options="options"
					class="form-control my-2 StyleInputText"
					placeholder="Teléfonos"
					ref="telefono"					
					v-model= "$v.telefono.$model"
				></cleave>
			</div>
			<div class="col-12">
				<input
					:class="{ 'is-invalid': $v.email.$error }"
					class="form-control my-2 StyleInputText"
					placeholder="Correo"
					ref="email"
					type="email"
					v-model="$v.email.$model"
				/>
			</div>
			<div class="col-12">
				<input
					:class="{ 'is-invalid': $v.ciudad.$error }"
					class="form-control my-2 StyleInputText"
					placeholder="Ciudad"
					ref="ciudad"
					type="ciudad"
					v-model="$v.ciudad.$model"
				/>
			</div>
			<div class="col-12">
				<input
					:class="{ 'is-invalid': $v.estado.$error }"
					class="form-control my-2 StyleInputText"
					placeholder="Estado"
					ref="estado"
					type="estado"
					v-model="$v.estado.$model"
				/>
			</div>
			<div class="col-12">
				<textarea
					:class="{ 'is-invalid': $v.mensaje.$error }"
					class="form-control my-2 StyleInputText"
					placeholder="Mensaje"
					ref="mensaje"
					rows="10"
					v-model="$v.mensaje.$model"
				></textarea>
			</div>
			<div class="col-12">
				<button @click="enviar" class="btn btn-block Button">Enviar</button>
			</div>
		</div>
	</div>
</template>
<script>
	import { required, minLength, email } from "vuelidate/lib/validators"
	import Cleave from "@/components/publica/Cleave"
	import servicio from "@/services/servicio-publica"

	export default {
		data() {
			return {
				nombre: null,
				telefono: null,
				email: null,
				ciudad:null,
				estado:null,
				mensaje: null,
				options: {
					phone: true,
					phoneRegionCode: "MX"
				},
				error: ""
			}
		},
		mounted() {
			//this.ocultarChat()
		},
		components: {
			Cleave
		},
		methods: {
			enviar() {
				if (!this.nombre) {
					this.$refs.nombre.focus()
				} else if (!this.telefono) {
					this.$refs.telefono.$el.focus()
				} else if (this.$v.email.$error) {
					this.$refs.email.focus()
				} else if(this.$v.ciudad.$error){
					this.$refs.ciudad.focus()

				} else if(this.$v.estado.$error){
					this.$refs.estado.focus()
				}				
				else if (!this.mensaje) {
					this.$refs.mensaje.focus()
				}
				this.$v.$touch()
				if (this.$v.$invalid) return

				servicio
					.contacto(this.nombre, this.email, this.telefono, this.mensaje, this.ciudad, this.estado)
					.then(r => {
						this.$swal.fire({
							text: r.message,
							icon: r.value ? "success" : "warning"
						})
						this.limpiarControles()
						this.$v.$reset()
					})
			},
			limpiarControles() {
				this.nombre = null
				this.telefono = null
				this.email = null
				this.ciudad = null
				this.estado = null
				this.mensaje = null
			}
		},
		validations: {
			nombre: {
				required
			},
			mensaje: {
				required
			},
			telefono: {
				required,
				minLength: minLength(10)
			},
			ciudad:{
				required
			},
			estado : {
				required
			},
			email: {
				required,
				email
			}
		}
	}
</script>

<style scoped>
	.Button {
		background: var(--color-azul);
		color: white;
	}
	.Button:hover {
		background-color: var(--color-amarillo); /* Green */
		color: black;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.StyleInputText {
			background: var(--color-gris-light) !important;
			border: 0;
			font-family: "Open Sans", sans-serif;
			font-size: 12px;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.StyleInputText {
			background: var(--color-gris-light) !important;
			border: 0;
			font-family: "Open Sans", sans-serif;
			font-size: 13px;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.StyleInputText {
			background: var(--color-gris-light) !important;
			border: 0;
			font-family: "Open Sans", sans-serif;
			font-size: 16px;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) {
		.StyleInputText {
			background: var(--color-gris-light) !important;
			font-family: "Open Sans", sans-serif;
			font-size: 18px;
		}
	}
</style>